import React from 'react';

/**
 * Skeleton loader for dashboard cards.
 * Shows animated placeholder while data is loading.
 */
export const CardSkeleton: React.FC = () => (
  <div className="bg-white rounded-lg shadow p-6 animate-pulse">
    <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
    <div className="h-8 bg-gray-200 rounded w-3/4 mb-2"></div>
    <div className="h-3 bg-gray-200 rounded w-1/3"></div>
  </div>
);

/**
 * Skeleton loader for the hero section (3 cards).
 */
export const HeroSkeleton: React.FC = () => (
  <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
    <CardSkeleton />
    <CardSkeleton />
    <CardSkeleton />
  </div>
);

/**
 * Skeleton loader for the alerts list.
 */
export const AlertsSkeleton: React.FC = () => (
  <div className="bg-white rounded-lg shadow p-6 animate-pulse">
    <div className="h-5 bg-gray-200 rounded w-1/3 mb-4"></div>
    <div className="space-y-3">
      <div className="flex items-center">
        <div className="h-4 w-4 bg-gray-200 rounded mr-3"></div>
        <div className="h-4 bg-gray-200 rounded flex-1"></div>
      </div>
      <div className="flex items-center">
        <div className="h-4 w-4 bg-gray-200 rounded mr-3"></div>
        <div className="h-4 bg-gray-200 rounded flex-1"></div>
      </div>
      <div className="flex items-center">
        <div className="h-4 w-4 bg-gray-200 rounded mr-3"></div>
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
      </div>
    </div>
  </div>
);

/**
 * Skeleton loader for the trend chart.
 */
export const ChartSkeleton: React.FC = () => (
  <div className="bg-white rounded-lg shadow p-6 animate-pulse">
    <div className="flex justify-between items-center mb-4">
      <div className="h-5 bg-gray-200 rounded w-1/4"></div>
      <div className="h-8 bg-gray-200 rounded w-32"></div>
    </div>
    <div className="h-64 bg-gray-100 rounded flex items-end justify-around p-4">
      {/* Fake bar chart lines */}
      <div className="w-8 bg-gray-200 rounded-t h-1/4"></div>
      <div className="w-8 bg-gray-200 rounded-t h-1/3"></div>
      <div className="w-8 bg-gray-200 rounded-t h-1/2"></div>
      <div className="w-8 bg-gray-200 rounded-t h-2/5"></div>
      <div className="w-8 bg-gray-200 rounded-t h-3/5"></div>
      <div className="w-8 bg-gray-200 rounded-t h-1/3"></div>
      <div className="w-8 bg-gray-200 rounded-t h-2/3"></div>
    </div>
  </div>
);

/**
 * Full dashboard skeleton showing all sections loading.
 */
const DashboardSkeleton: React.FC = () => (
  <div className="space-y-6">
    <HeroSkeleton />
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2">
        <ChartSkeleton />
      </div>
      <AlertsSkeleton />
    </div>
  </div>
);

export default DashboardSkeleton;
